import { authEndpoints as auth } from '@/api/endpoints/auth';
import { registrationEndpoints as registration } from '@/api/endpoints/registration';
import { placesEndpoints as places } from '@/api/endpoints/places';
import { fnEndpoints as fn } from '@/api/endpoints/fn';
import { infoEndpoints as info } from '@/api/endpoints/info';
import { userEndpoints as user } from '@/api/endpoints/user';

export const ENDPOINTS = { auth, registration, places, fn, info, user };
